<div id="distance" class="container mx-auto" data-cy="distance">
  <div class="form" [formGroup]="control">
    <ife-title
      [title]="'modules.evcQuote.steps.technicalDetails.steps.distance.title' | translate"
      [subtitle]="'modules.evcQuote.steps.technicalDetails.steps.distance.description' | translate"
      data-cy="distance-title"
    ></ife-title>

    <div class="form-element input-text">
      <input
        id="distance-input"
        data-cy="distance-input"
        type="number"
        (keypress)="allowDigitsOnly($event)"
        formControlName="value"
        class="w-32 pl-12"
        autocomplete="off"
        inputmode="numeric"
        pattern="[0-9]*"
      />
      <label for="distance-input" class="px-4">
        {{ "modules.evcQuote.steps.technicalDetails.steps.distance.label" | translate }}
      </label>
    </div>

    <ife-navigation
      [showNext]="control.valid"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>
</div>
